import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Icon } from '../../../common/html/icon'
import { SelectCurrencyUnit } from '../../../common/selectCurrencyUnit'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { Tooltip } from '../../../common/tooltip'
import { COMPANY_NON_BANK_TYPES, COMPANY_TYPES } from '../../../utils/common'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import { Filter } from '../../common/header/filterBar'
import { FiscalYear } from '../../common/header/fiscalYear'
import { DefaultVsicName } from './DefaultVsicName'
import { selectTopYears } from './topIndustryPlayers/store/slice'

export const Sticky = () => {
  const companyInfo = useSelector(selectCompanyInfo)
  const topYears = useSelector(selectTopYears)
  const fiscalYear = topYears.length ? topYears[0] : undefined

  const getCompanyTypeName = () => {
    switch (companyInfo.companyType) {
      case COMPANY_TYPES.BANK:
        return <Translate value="industryOverview.BANKING_INDUSTRY" />
      case COMPANY_TYPES.NON_BANK:
        switch (companyInfo.companyTypeOrigin) {
          case COMPANY_NON_BANK_TYPES.NON_BANK_FIC:
            return <Translate value="industryOverview.NON_BANK_FIC_INDUSTRY" />
          case COMPANY_NON_BANK_TYPES.NON_BANK_FIO:
            return <Translate value="industryOverview.NON_BANK_FIO_INDUSTRY" />
          case COMPANY_NON_BANK_TYPES.NON_BANK_LEA:
            return <Translate value="industryOverview.NON_BANK_LEA_INDUSTRY" />
          default:
            return ''
        }
      case COMPANY_TYPES.SECURITIES:
        return <Translate value="industryOverview.SECURITIES_INDUSTRY" />
      case COMPANY_TYPES.LIFE_INSURANCE:
        return <Translate value="industryOverview.LIFE_INSURANCE_INDUSTRY" />
      case COMPANY_TYPES.NON_LIFE_INSURANCE:
        return (
          <Translate value="industryOverview.NON_LIFE_INSURANCE_INDUSTRY" />
        )
      default:
        return <DefaultVsicName isLevel1={false} isOnSticky />
    }
  }

  const renderLeft = () => {
    return (
      <div className="dFlex">
        <Translate value="industryOverview.INDUSTRY" className="fw600" />
        <Tooltip
          isI18n
          tooltipContent="industryOverview.TOOLTIP_INDUSTRY"
          tooltipContentStyle={{ width: 400 }}
        >
          <Icon
            className="icon-info-circle"
            style={{
              fontSize: 14,
              color: '#9C9C9C',
              marginLeft: 4,
              marginTop: 4,
            }}
          />
        </Tooltip>
        &nbsp;&nbsp;
        {getCompanyTypeName()}
      </div>
    )
  }

  return (
    <Filter
      renderLeft={renderLeft}
      renderRight={() => (
        <>
          <FiscalYear otherFiscalYearEnd={fiscalYear} />
          <SelectCurrencyUnit screen={SCREEN.INDUSTRY_OVERVIEW} />
        </>
      )}
    />
  )
}
